const AMZ_SIGNED_AT_PATTERN = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/;

export const describeSignedUrlLifetime = (url: string, now = Date.now()) => {
  let params: URLSearchParams;

  try {
    params = new URL(url).searchParams;
  } catch {
    return {};
  }

  const signedAt = AMZ_SIGNED_AT_PATTERN.exec(params.get('X-Amz-Date') ?? '');

  if (!signedAt) {
    return {};
  }

  const [, year, month, day, hour, minute, second] = signedAt;
  const signedAtMs = Date.parse(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);

  if (Number.isNaN(signedAtMs)) {
    return {};
  }

  const expiresInSeconds = Number(params.get('X-Amz-Expires'));
  const hasExpiry = Number.isFinite(expiresInSeconds) && expiresInSeconds > 0;

  return {
    urlAgeInSeconds: Math.round((now - signedAtMs) / 1000),
    ...(hasExpiry ? { urlExpiresInSeconds: expiresInSeconds } : {}),
  };
};
